// ═══════════════════════════════════════════════════════════════
// SENSANDO Design System — Custom ECharts Theme
// Registers a 'sensando' theme matching the tactical dark palette
// ═══════════════════════════════════════════════════════════════

import { registerTheme } from 'echarts/core'

const sensandoTheme = {
  // ─── Color Palette ───
  color: [
    '#7C3AED', // primary violet
    '#06B6D4', // info cyan
    '#10B981', // success emerald
    '#F59E0B', // warning amber
    '#EF4444', // error red
    '#8B5CF6', // lighter violet
    '#EC4899', // pink
    '#F97316', // orange
  ],

  // ─── Background ───
  backgroundColor: 'transparent',

  // ─── Title ───
  title: {
    textStyle: {
      color: '#E2E8F0',
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "'Inter', -apple-system, sans-serif",
    },
    subtextStyle: {
      color: '#94A3B8',
      fontSize: 11,
      fontFamily: "'Inter', -apple-system, sans-serif",
    },
  },

  // ─── Legend ───
  legend: {
    textStyle: {
      color: '#94A3B8',
      fontSize: 10,
      fontFamily: "'Inter', -apple-system, sans-serif",
    },
    inactiveColor: '#334155',
  },

  // ─── Tooltip ───
  tooltip: {
    backgroundColor: '#1A1F2E',
    borderColor: 'rgba(124, 58, 237, 0.2)',
    borderWidth: 1,
    textStyle: {
      color: '#E2E8F0',
      fontSize: 11,
      fontFamily: "'Inter', -apple-system, sans-serif",
    },
    extraCssText: 'border-radius: 6px; box-shadow: 0 4px 24px rgba(0,0,0,0.4);',
  },

  // ─── Axis ───
  categoryAxis: {
    axisLine: { lineStyle: { color: 'rgba(124, 58, 237, 0.1)' } },
    axisTick: { lineStyle: { color: 'rgba(124, 58, 237, 0.1)' } },
    axisLabel: {
      color: '#94A3B8',
      fontSize: 10,
      fontFamily: "'JetBrains Mono', monospace",
    },
    splitLine: { lineStyle: { color: 'rgba(124, 58, 237, 0.06)' } },
  },
  valueAxis: {
    axisLine: { lineStyle: { color: 'rgba(124, 58, 237, 0.1)' } },
    axisTick: { lineStyle: { color: 'rgba(124, 58, 237, 0.1)' } },
    axisLabel: {
      color: '#94A3B8',
      fontSize: 10,
      fontFamily: "'JetBrains Mono', monospace",
    },
    splitLine: { lineStyle: { color: 'rgba(124, 58, 237, 0.06)' } },
  },
  timeAxis: {
    axisLine: { lineStyle: { color: 'rgba(124, 58, 237, 0.1)' } },
    axisTick: { lineStyle: { color: 'rgba(124, 58, 237, 0.1)' } },
    axisLabel: {
      color: '#94A3B8',
      fontSize: 10,
      fontFamily: "'JetBrains Mono', monospace",
    },
    splitLine: { lineStyle: { color: 'rgba(124, 58, 237, 0.06)' } },
  },

  // ─── DataZoom ───
  dataZoom: {
    backgroundColor: '#111827',
    dataBackgroundColor: 'rgba(124, 58, 237, 0.1)',
    fillerColor: 'rgba(124, 58, 237, 0.15)',
    handleColor: '#7C3AED',
    handleSize: '100%',
    textStyle: { color: '#94A3B8' },
    borderColor: 'transparent',
  },

  // ─── Grid ───
  grid: {
    borderColor: 'rgba(124, 58, 237, 0.06)',
  },

  // ─── Gauge ───
  gauge: {
    axisLine: {
      lineStyle: {
        color: [[1, 'rgba(124, 58, 237, 0.15)']],
      },
    },
    axisTick: { lineStyle: { color: '#475569' } },
    axisLabel: { color: '#94A3B8' },
    detail: {
      color: '#E2E8F0',
      fontFamily: "'JetBrains Mono', monospace",
    },
  },

  // ─── Series defaults ───
  line: {
    smooth: true,
    symbol: 'circle',
    symbolSize: 4,
    lineStyle: { width: 2 },
  },
  bar: {
    barMaxWidth: 30,
    itemStyle: {
      borderRadius: [4, 4, 0, 0],
    },
  },
  pie: {
    itemStyle: {
      borderColor: '#111827',
      borderWidth: 2,
    },
  },
}

registerTheme('sensando', sensandoTheme)

export default sensandoTheme
